import { Joi } from 'celebrate'
import { RateSchema } from './rates-schema'

export const verticals = [
  { id: 'mortgage', name: 'Mortgage' },
  { id: 'auto', name: 'Auto' },
  { id: 'home-equity', name: 'Home Equity' },
  { id: 'personal-loans', name: 'Personal Loans' },
  { id: 'credit-cards', name: 'Credit Cards' }
]

const vertical = Joi.string().valid(...verticals.map(v => v.id))

const defaultExpirationDay = Joi.string().valid(
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday'
)

const status = Joi.string().valid(
  'NEED_ENTRY',
  'NEED_QC',
  'PUBLISHED_QC',
  'PUBLISHED'
)

const CommentSchema = Joi.object()
  .required()
  .keys({
    id: Joi.number().required(),
    rate_set_id: Joi.number().required(),
    user_id: Joi.string().required(),
    comment: Joi.string().required(),
    created_at: Joi.date(),
    updated_at: Joi.date(),
    deleted_at: Joi.date().allow(null).optional()
  })
  .description('This is what a Comment looks like')
  .meta({ className: 'Comment' })

export const UserSchema = Joi.object()
  .optional()
  .keys({
    user_id: Joi.string().required(),
    name: Joi.string().required(),
    email: Joi.string().required(),
    picture: Joi.string().required()
  })
  .description('This is the schema of a user.')
  .meta({ className: 'User' })

export const RateSetSchema = Joi.object()
  .required()
  .keys({
    id: Joi.number().optional(),
    advertiser_id: Joi.number().required(),
    vertical: vertical.required(),
    display_name: Joi.string().allow(null).optional(),
    markets: Joi.array().items(Joi.number()).required(),
    products: Joi.array().items(Joi.number()).optional(),
    status: status.optional(),
    bypass_qc: Joi.boolean().default(false),
    default_expiration_day: defaultExpirationDay.allow(null).optional(),
    assigned_user_id: Joi.string().allow(null).optional(),
    assigned_user: UserSchema,
    review_user_id: Joi.string().allow(null).optional(),
    review_user: UserSchema,
    last_updated_user_id: Joi.string().allow(null).optional(),
    last_updated_user: UserSchema,
    expiration_date: Joi.date().allow(null).optional(),
    review_date: Joi.date().allow(null).optional(),
    rates: Joi.array().items(RateSchema).allow(null).optional(),
    comments: Joi.array().items(CommentSchema).allow(null).optional(),
    attributes: Joi.object().allow(null).optional(),
    created_at: Joi.date(),
    updated_at: Joi.date(),
    deleted_at: Joi.date().allow(null).optional()
  })
  .description('This is what a RateSet looks like')
  .meta({ className: 'RateSet' })

export const RateSetUpdateSchema = Joi.object()
  .required()
  .keys({
    display_name: Joi.string().optional(),
    assigned_user_id: Joi.string().allow(null).optional(),
    expiration_date: Joi.date().allow(null).optional(),
    markets: Joi.array().items(Joi.number()).optional(),
    bypass_qc: Joi.boolean().optional(),
    status: status.optional(),
    attributes: Joi.object().allow(null).optional(),
  })
  .min(1)
  .description('This is what a RateSet update looks like')
